import * as actionTypes from '../../../actions/actionTypes';
import { updateObject } from '../../../utility';

const initialState = {
  accountId: null,
  accountData: null,
  msg: null,
  loading: null,
  error: null,
};

const setAccountId = (state, action) => {
  return updateObject(state, { accountId: action.accountId });
};

const fetchInfoStart = (state, action) => {
  return updateObject(state, { error: null, loading: true });
};

const fetchInfoSuccess = (state, action) => {
  return updateObject(state, {
    accountData: action.data,
    error: null,
    loading: false,
  });
};

const fetchInfoFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// for update account
const updateInfoStart = (state, action) => {
  return updateObject(state, { msg: null, error: null, loading: true });
};

const updateInfoSuccess = (state, action) => {
  return updateObject(state, {
    msg: action.msg,
    data: action.newInfo,
    error: null,
    loading: false,
  });
};

const updateInfoFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    msg: null,
  });
};

// for delete
const deleteAccountStart = (state, action) => {
  return updateObject(state, { error: null, loading: true });
};

const deleteAccountSuccess = (state, action) => {
  return updateObject(state, {
    msg: action.msg,
    error: null,
    loading: false,
  });
};

const deleteAccountFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const clearMsgAccount = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
    msg: null,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_ACCOUNT_ID:
      return setAccountId(state, action);

    case actionTypes.FETCH_ACCOUNT_START:
      return fetchInfoStart(state, action);
    case actionTypes.FETCH_ACCOUNT_SUCCESS:
      return fetchInfoSuccess(state, action);
    case actionTypes.FETCH_ACCOUNT_FAIL:
      return fetchInfoFail(state, action);

    case actionTypes.UPDATE_ACCOUNT_START:
      return updateInfoStart(state, action);
    case actionTypes.UPDATE_ACCOUNT_SUCCESS:
      return updateInfoSuccess(state, action);
    case actionTypes.UPDATE_ACCOUNT_FAIL:
      return updateInfoFail(state, action);

    case actionTypes.DELELTE_ACCOUNT_START:
      return deleteAccountStart(state, action);
    case actionTypes.DELELTE_ACCOUNT_SUCCESS:
      return deleteAccountSuccess(state, action);
    case actionTypes.DELELTE_ACCOUNT_FAIL:
      return deleteAccountFail(state, action);

    case actionTypes.CLEAR_ACCOUNT_MSG:
      return clearMsgAccount(state, action);
    default:
      return state;
  }
};

export default reducer;
